import {Component, OnInit} from '@angular/core';
import {GraphService} from '../../../services/graph.service';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {BwGraph} from '../../../models/bwGraph';

@Component({
  selector: 'app-bw-graph-crud',
  templateUrl: './bw-graph-crud.component.html',
  styleUrls: ['./bw-graph-crud.component.scss']
})
export class BwGraphCrudComponent implements OnInit {
  action: string;
  bwGraphsForm: any;
  bwGraph: BwGraph;
  error: boolean;
  errorMessage: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private graphService: GraphService) {
  }

  ngOnInit() {
    this.createFormGroup();
    this.action = this.config.data['isNewGraph'] ? 'new' : 'edit';
    if (this.isEditAction) {
      this.bwGraph = this.config.data['graph'];
      this.bwGraphsForm.patchValue(this.bwGraph);
      this.bwGraphsForm.get('uniqId').disable();
    }
  }

  createFormGroup() {
    this.bwGraphsForm = this.formBuilder.group(
      {
        originPop: ['', Validators.required],
        destinationPop: ['', Validators.required],
        vvlanId: ['', [Validators.required]],
        uniqId: ['', Validators.required]
      },
    );
  }

  onSubmit() {
    if (!this.bwGraphsForm.valid) {
      return;
    }
    if (this.isEditAction) {
      this.editBwGraph();
      return;
    }
    this.addBwGraph();
  }

  private addBwGraph() {
    const existingGraphs = this.config.data['existingGraphs'];
    const graphsWithSameUniqId = existingGraphs.filter(graph =>
      graph.uniqId === this.bwGraphsForm.get('uniqId').value
      && graph.originPop === this.bwGraphsForm.get('originPop').value);
    if (graphsWithSameUniqId.length > 0) {
      this.error = true;
      this.errorMessage = 'The combination between origin pop and uniq id must be unique.';
      return;
    }
    this.graphService.addBwGraph(this.bwGraphsForm.value).subscribe({
        next: res => {
          this.ref.close(res);
        },
        error: error => {
          this.error = true;
          this.errorMessage = error.message;
        }
      }
    );
  }

  private editBwGraph() {
    this.graphService.editBwGraph(this.bwGraph.id, this.bwGraphsForm.value).subscribe({
        next: res => {
          this.ref.close(res);
        },
        error: error => {
          this.error = true;
          this.errorMessage = error.message;
        }
      }
    );
  }

  get isEditAction(): boolean {
    return this.action === 'edit';
  }
}
